import { render } from "./Pending.vue?vue&type=template&id=0e889675&scoped=true"
import script from "./Pending.vue?vue&type=script&lang=js"
export * from "./Pending.vue?vue&type=script&lang=js"

import "./Pending.vue?vue&type=style&index=0&id=0e889675&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e889675"]])

export default __exports__